'use client';

import { usePathname } from 'next/navigation';

import { useEffect } from 'react';

import { sendGTMEvent } from './google-tag-manger';

export const GTMTrackPageView = () => {
    const pathname = usePathname();

    // Track page views when the route changes
    useEffect(() => {
        if (pathname) {
            // Push to dataLayer
            sendGTMEvent({
                event: 'dlv_push_page_view',
            });
        }
    }, [pathname]);

    return null;
};
